<template>
  <div class="row upload-cover-container">
    <div class="gr-12 gr-8@desktop gr-8@tablet-large gr-10@tablet upload-cover">
      <p v-if="error" class="error">
        {{ trans('media.cover.error') }}
      </p>
      <div v-if="uuid" class="upload-cover__preview">
        <div class="inner">
          <div class="upload-media-preview">
            <h2 class="medias-subtitle">
              {{ trans('media.cover.label') }}
            </h2>
            <div
              class="upload-media-preview__img preview-img"
              :class="{ 'preview-img--loading': loading }"
            >
              <div v-if="validating" class="alert-component-container">
                <div class="alert-component">
                  <div class="alert-component__icon" />
                  <span class="alert-component__text">{{ trans('form.offer.field.validation') }}</span>
                </div>
              </div>
              <media-image
                :uuid="uuid"
                :format="null"
                :density="1"
                only-img
              />
              <upload-media-image
                v-model="uuid"
                @loading="loading = true"
                @done="loading = false"
              >
                <div class="btn upload-media-preview-details__modify" role="button" />
              </upload-media-image>
              <div v-if="loading" class="preview-img__spinner">
                <spinner :size="40" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <upload-media-image
        v-else
        v-model="uuid"
        droppable
        @loading="loading = true"
        @done="loading = false"
      >
        <div class="upload-cover__add cover-add">
          <div
            class="cover-add__slot add-slot"
            :class="{ 'add-slot--loading': loading }"
          >
            <div v-if="loading" class="add-slot__spinner">
              <spinner :size="40" />
            </div>
            <div role="button" class="btn btn--add btn--primary">
              <span>
                {{ trans('media.cover.label') }}
              </span>
            </div>
          </div>
        </div>
      </upload-media-image>
    </div>
    <input v-model="uuid" type="hidden" name="cover">
  </div>
</template>

<script>

import MediaImage from '@components/MediaImage.vue';
import Spinner from '@components/Spinner.vue';
import UploadMediaImage from '@components/UploadMediaImage.vue';
import { trans } from '@elements/translation';

export default {
  components: { UploadMediaImage, MediaImage, Spinner },
  props: {
    modelValue: { type: String, default: null },
    error: { type: Boolean, default: false },
    validating: { type: Boolean, default: false },
  },
  emits: [ 'update:modelValue' ],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    uuid: {
      get() {
        return this.modelValue;
      },
      set(uuid) {
        this.$emit('update:modelValue', uuid);
      },
    },
  },
  methods: {
    trans,
  },
};

</script>
